import { useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * Recibe el mensaje "notification-click" del service worker y navega dentro de la SPA
 * a la URL de la notificación. Montar dentro de BrowserRouter.
 */
export const BrowserNotificationClickHandler = () => {
  const history = useHistory();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type !== "notification-click" || !event.data.url) return;
      const url = new URL(event.data.url, window.location.origin);
      if (url.origin !== window.location.origin) return;
      history.push(url.pathname + url.search + url.hash);
    };

    navigator.serviceWorker.addEventListener("message", handleMessage);
    return () =>
      navigator.serviceWorker.removeEventListener("message", handleMessage);
  }, [history]);

  return null;
};
